// 暴漏 window.$
import 'jquery'

// import global css
import './assets/styles/global.scss'

// import components
import './components'

import './assets/scripts/common.js'

process.env.LANG === 'en' && require('./assets/styles/en.scss')
process.env.LANG === 'cn' && require('./assets/scripts/defend_cn.js')
process.env.LANG === 'en' && require('./assets/scripts/defend_en.js')

// swiper4
// @import "~swiper/dist/css/swiper.min.css";
// import Swiper from 'swiper/dist/js/swiper.min.js'

// swiper5
// @import "~swiper/css/swiper.min.css";
// import Swiper from 'swiper/js/swiper.min.js'

// swiper6+
// @import "~swiper/swiper-bundle.min.css";
// import Swiper from 'swiper/swiper-bundle.min.js'

// import '@fancyapps/fancybox/dist/jquery.fancybox.min'